export const REIMBURSEMENT_TYPE = [1, 3, 7];

export const USER_CONSTRAINS = {
  first_name: {
    presence: {message: 'First name is required'},
    length: {
      maximum: 20,
      tooLong: 'First name allowed only 20 symbols'
    }
  },
  last_name: {
    presence: {message: 'Last name is required'},
    length: {
      maximum: 20,
      tooLong: 'Last name allowed only 20 symbols'
    }
  },
  email: {
    email: {message: 'Email invalid'}
  },
  password: {
    format: {
      pattern: '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,})',
      message: 'Must be at least 6 characters and contain at least one number and one capital letter'
    }
  },
  password_confirmation: {
    equality: {
      attribute: 'password',
      message: 'Confirmation Password must be the same as Password'
    }
  }
};

export const LOGIN_USER = {
  email: {
    email: {message: 'Email invalid'}
  },
  password: {
   presence: {message: 'Password is required' }
  }
};


export const NEW_PASSWORD = {
  password: {
    format: {
      pattern: '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,})',
      message: 'Must be at least 6 characters and contain at least one number and one capital letter'
    }
  },
  password_confirmation: {
    equality: {
      attribute: 'password',
      message: 'The New Password must be the same as the Repeat New Password'
    }
  }
};


export const USER_UPDATE_CONSTRAINS = {
  email: {
    presence: { message: 'Email is required' },
    email: { message: 'Email invalid' }
  },
  first_name: {
    presence: {message: 'First name is required'},
    length: {
      maximum: 20,
      tooLong: 'First name allowed only 20 symbols'
    }
  },
  last_name: {
    presence: {message: 'Last name is required'},
    length: {
      maximum: 20,
      tooLong: 'Last name allowed only 20 symbols'
    }
  }
};



// WEBPACK FOOTER //
// ./src/constants/usersConstrains.js